import { render, staticRenderFns } from "./trashList.vue?vue&type=template&id=320dd8f4&scoped=true&"
import script from "./trashList.vue?vue&type=script&lang=js&"
export * from "./trashList.vue?vue&type=script&lang=js&"
import style0 from "./trashList.vue?vue&type=style&index=0&id=320dd8f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320dd8f4",
  null
  
)

export default component.exports